export default "__VITE_ASSET__CXaqOy80__"